import * as TYPES from "../types/types";

const initialState = {
  bliSirenIdReport: [],
  searchPatientsList: [],
  billingTableList: [],
  billingTableList_99454: [],
  selectSirenIdReport: [],
  billing99457BilledPatients: [],
  billingPCMBilledPatients: [],
  billing99457UnbilledPatients: [],
  billingPCMUnbilledPatients: [],
  count99457Unbilled: 0,
  countPCMUnbilled: 0,
  billing99454UnbilledPatients: [],
  showGenerate99457Delay: false,
  showGeneratePCMDelay: false,
  generate99457Delay: "",
  generatePCMDelay: "",
  curMonthPatients99457: [],
  curMonthPatientsPCM: [],
  billing99454BilledPatients: [],
  count99454Unbilled: 0,
  billing99453BilledPatients: [],
  billing99453UnbilledPatients: [],
  count99453Unbilled: 0,
  showGenerate99454Delay: false,
  showGenerateVaDelay: false,
  generate99454Delay: "",
  generateVaDelay: "",
  curMonthPatients99453: []
};

export default function monthlyReportReducer(state = initialState, action) {
  switch (action.type) {
    case TYPES.BLI_SIRENID_REPORT:
      return {
        ...state,
        bliSirenIdReport: action.text
      };
    case TYPES.RESET_ALL_SIRENID:
      return {
        ...state,
        bliSirenIdReport: []
      };
    case TYPES.SEARCH_PATIENTS_LIST:
      return {
        ...state,
        searchPatientsList: action.text
      };
    case TYPES.BILLING_TABLE_LIST:
      return {
        ...state,
        billingTableList: action.text
      };
    case TYPES.BILLING_TABLE_LIST_99454:
      return {
        ...state,
        billingTableList_99454: action.text
      };
    case TYPES.SEL_SIRENID_REPORT:
      return {
        ...state,
        selectSirenIdReport: action.text
      };
    case TYPES.BILLING_99457_Billed_PATIENTS:
      return {
        ...state,
        billing99457BilledPatients: action.text
      };
    case TYPES.BILLING_PCM_Billed_PATIENTS:
      return {
        ...state,
        billingPCMBilledPatients: action.text
      };
    case TYPES.BILLING_99457_Unbilled_PATIENTS:
      return {
        ...state,
        billing99457UnbilledPatients: action.text
      };
    case TYPES.BILLING_PCM_Unbilled_PATIENTS:
      return {
        ...state,
        billingPCMUnbilledPatients: action.text
      };
    case TYPES.COUNT_99457_UNBILLED:
      return {
        ...state,
        count99457Unbilled: action.text
      };
    case TYPES.COUNT_PCM_UNBILLED:
      return {
        ...state,
        countPCMUnbilled: action.text
      };
    case TYPES.BILLING_99454_Unbilled_PATIENTS:
      return {
        ...state,
        billing99454UnbilledPatients: action.text
      };
    case TYPES.SHOW_GENERATE_99457_DELAY:
      return {
        ...state,
        showGenerate99457Delay: action.text
      };
    case TYPES.SHOW_GENERATE_PCM_DELAY:
      return {
        ...state,
        showGeneratePCMDelay: action.text
      };
    case TYPES.GENERATE_99457_DELAY:
      return {
        ...state,
        generate99457Delay: action.text
      };
    case TYPES.GENERATE_PCM_DELAY:
      return {
        ...state,
        generatePCMDelay: action.text
      };
    case TYPES.CURMONTH_PATIENTS_99457:
      return {
        ...state,
        curMonthPatients99457: action.text
      };
    case TYPES.CURMONTH_PATIENTS_PCM:
      return {
        ...state,
        curMonthPatientsPCM: action.text
      };
    case TYPES.BILLING_99454_Billed_PATIENTS:
      return {
        ...state,
        billing99454BilledPatients: action.text
      };
    case TYPES.COUNT_99454_UNBILLED:
      return {
        ...state,
        count99454Unbilled: action.text
      };
    case TYPES.BILLING_99453_Billed_PATIENTS:
      return {
        ...state,
        billing99453BilledPatients: action.text
      };
    case TYPES.BILLING_99453_Unbilled_PATIENTS:
      return {
        ...state,
        billing99453UnbilledPatients: action.text
      };
    case TYPES.COUNT_99453_UNBILLED:
      return {
        ...state,
        count99453Unbilled: action.text
      };
    case TYPES.SHOW_GENERATE_99454_DELAY:
      return {
        ...state,
        showGenerate99454Delay: action.text
      };
    case TYPES.SHOW_GENERATE_VA_DELAY:
      return {
        ...state,
        showGenerateVaDelay: action.text
      };
    case TYPES.GENERATE_99454_DELAY:
      return {
        ...state,
        generate99454Delay: action.text
      };
    case TYPES.GENERATE_VA_DELAY:
      return {
        ...state,
        generateVaDelay: action.text
      };
    case TYPES.CURMONTH_PATIENTS_99453:
      return {
        ...state,
        curMonthPatients99453: action.text
      };
    default:
      return state;
  }
}
